(ns minorodata.group.subs
  (:require [re-frame.core :as re-frame]
            [minorodata.app.utils :as utils]
            [clojure.string]))


(defn format-panel-group [{:group/keys [id name updated-by updated-at bulk-scheduled]} unsaved panel]
  {:id         id
   :name       name
   :updated-at updated-at
   :updated-by (:searchable-user/username updated-by)
   :scheduled? bulk-scheduled
   :unsaved?   (some? unsaved)
   :selected?  (= id (get-in panel [:groups-panel/active-group :group/id]))})


(re-frame/reg-sub
  :group.subs/panel-group
  (fn [[_ group-id]]
    [(re-frame/subscribe [:group/pull [:group/id group-id] '[* {:group/updated-by [:searchable-user/username]}]])
     (re-frame/subscribe [:unsaved-group/pull [:unsaved-group/id group-id]])
     (re-frame/subscribe [:groups-panel/pull '[{:groups-panel/active-group [:group/id]}]])])
  (fn [[group unsaved panel]]
    (when (some? group)
      (format-panel-group group unsaved panel))))


(defn format-group-details [group unsaved]
  (let [{:group/keys [id updated-by updated-at created-by created-at bulk-scheduled schedulable? schedule-tip schedule-spec]} group
        edited-group (merge (utils/drop-ns-in-keys group)
                            (utils/drop-ns-in-keys unsaved))]
    {:id            id
     :name          (:name edited-group)
     :description   (:description edited-group)
     :updated-at    updated-at
     :updated-by    (:searchable-user/username updated-by)
     :created-at    created-at
     :created-by    (:searchable-user/username created-by)
     :scheduled?    bulk-scheduled
     :schedule-spec schedule-spec
     :schedulable?  schedulable?
     :schedule-tip  (or schedule-tip "")
     :changed?      (some? unsaved)}))


(re-frame/reg-sub
  :group.subs/panel-group-details
  (fn [[_ group-id]]
    [(re-frame/subscribe [:group/pull [:group/id group-id] '[* {:group/updated-by [:searchable-user/username]
                                                                :group/created-by [:searchable-user/username]}]])
     (re-frame/subscribe [:unsaved-group/pull [:unsaved-group/id group-id]])])
  (fn [[group unsaved]]
    (when (some? group)
      (format-group-details group unsaved))))


(defn format-group [{:group/keys [id name description]}]
  {:id          id
   :name        name
   :description description})


(re-frame/reg-sub
  :group.subs/groups-search-results
  (fn []
    (re-frame/subscribe
      [:transformations-search/pull '[{:transformations-search/groups [:group/id :group/name :group/description]}]]))
  (fn [search]
    (let [{:transformations-search/keys [groups]} search]
      (map format-group groups))))


(re-frame/reg-sub
  :group.subs/ordered-groups
  (fn []
    (re-frame/subscribe [:groups-panel/pull '[{:groups-panel/groups [:group/id :group/order *]}]]))
  (fn [panel]
    (let [{:groups-panel/keys [groups]} panel]
      (sort-by :group/order groups))))

(re-frame/reg-sub
 :group.subs/new-transform-template-code
 (fn []
   (re-frame/subscribe [:app.subs/get-local-storage "new-transform-template-code"]))
 (fn [code]
   (when (and (some? code)
              (not (clojure.string/blank? code)))
     code)))
